import dayjs from "dayjs";

const ORDER_STATUS_COMPLETED = 8;

export const addOneSignalData = ({user = {}, orders = [], results = [], subscriptions = []}) => {
  const allSubscription = {
    ...(subscriptions?.free ?? {}),
    ...(subscriptions?.paypal ?? {}),
    ...(subscriptions?.stripe ?? {}),
  };

  const hasActiveSubscription = Object.values(allSubscription)?.some(sub => sub?.status === "Active");
  const ordersList = orders?.filter(order => order?.orderLabStatus == ORDER_STATUS_COMPLETED);
  const lastOrder = [...ordersList].sort((a, b) => b.orderDate - a.orderDate)?.[0] || {};
  const totalOfOrders = ordersList?.length || 0;

  const ageRanges = [
    "18 - 24",
    "25 - 29",
    "30 - 34",
    "35 - 39",
    "40 - 44",
    "45 - 49",
    "50 - 54",
    "55 - 59",
    "60 - 64",
    "65 - 69",
    "70 - 74",
    "75 - 79",
    "> 80",
  ];

  const customerAgeRange = ageRanges.find(range => {
    const [min, max] = range.split(" - ");
    const minAge = parseInt(min);
    const maxAge = parseInt(max);
    return user?.customerAge >= minAge && user?.customerAge <= maxAge;
  });

  const lastPurchaseDate = dayjs(lastOrder?.orderDate).isValid() ? dayjs(lastOrder?.orderDate).format("YYYYMMDD") : "";
  const latestResultReleaseDate =
    results.length > 0 && dayjs(results?.[0]?.orderCompleteDate).isValid()
      ? dayjs(results?.[0]?.orderCompleteDate).format("YYYYMMDD")
      : "";

  const tags = {
    tags: {
      sex: user?.customerSexLabel,
      ageRange: customerAgeRange,
      activeSubscription: hasActiveSubscription ? "1" : "0",
      lastPurchaseDate,
      latestResultReleaseDate,
      numberOfTests: totalOfOrders,
    },
  };

  window?.median?.onesignal?.tags.setTags(tags);
};
